"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RECEIVE_P2P_MESSAGE = void 0;
exports.RECEIVE_P2P_MESSAGE = "RECEIVE_P2P_MESSAGE";
function default_1(chatId, message) {
    return (dispatch, getState) => {
        // If the sender is blocked then ignore this message
        const blockedUsers = getState().chatsState.blockedUsers;
        if (blockedUsers.includes(message.sender)) {
            return null;
        }
        const event = {
            type: exports.RECEIVE_P2P_MESSAGE,
            payload: {
                chatId,
                message
            }
        };
        dispatch(event);
        return event;
    };
}
exports.default = default_1;
